import React from "react";
import "./footerStyle.css";

function Footer() {
  return <div className="footerBox"></div>;
}

export default Footer;
